import * as graphql from 'generated/graphql';
import Emoticon from '../layout/Emoticon';
import EmoticonContainer from '../layout/EmoticonContainer';

export default function StarsDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	const value = props.item.stars!;

	return (
		<EmoticonContainer>
			{[1, 2, 3, 4, 5].map((_, index) => (
				<Emoticon key={index} selected={value >= index}>
					⭐
				</Emoticon>
			))}
		</EmoticonContainer>
	);
}
